import { styled } from 'linaria/react';

const StyledLoader = styled.div<{ size: number; isDark: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

export default StyledLoader;
